import React, { memo } from 'react';
import { useQueryFetch } from '@ace/react-utilities';
import { IconLoadingCircle } from '@ace/react-icons';
import { useEmitterListener, USE_RETRIEVE_DATA_EVENTS } from '@ace/react-utilities';
import * as Sentry from "@sentry/react";

const ErrorDisplay = memo(({error}) => (<div>Error: {error.message}</div>));
const LoadingDisplay = memo(() => (<div style={{ height: '100%', display: 'grid', placeItems: 'center'}}><IconLoadingCircle/></div>)); //memo(() => (<div>Loading...</div>));

export default function LoadingHandler({retrievalUrl, componentName, queryOpts = {}, children}) {
    const { error, isLoading, data } = useQueryFetch(componentName, retrievalUrl, queryOpts);

    useEmitterListener(componentName, USE_RETRIEVE_DATA_EVENTS.ON_FETCH_ERROR, (err) => {
        Sentry.captureException(err);
    });

    return (
        <LoadingWrapper error={error} isLoading={isLoading} data={data}>
            {(data) => (children(data))}
        </LoadingWrapper>
    );
}

export function LoadingWrapper(props) {
    const { error, isLoading, data, children } = props;

    if (data) {
        return children(data);
    } else if (error) {
        return <ErrorDisplay error={error} />;
    } else if (isLoading) {
        return <LoadingDisplay />;
    } else {
        return false;
    }
}